export class KafkaSourceProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "source",
            "baseName": "source",
            "type": "KafkaSourceConfig",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        },
        {
            "name": "schemaRegistry",
            "baseName": "schemaRegistry",
            "type": "SchemaRegistryConfig",
            "format": ""
        },
        {
            "name": "partitioning",
            "baseName": "partitioning",
            "type": "KafkaPartitioningConfig",
            "format": ""
        },
        {
            "name": "batch",
            "baseName": "batch",
            "type": "KafkaBatchConfig",
            "format": ""
        },
        {
            "name": "errorHandling",
            "baseName": "errorHandling",
            "type": "KafkaErrorHandlingConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
